/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import NoiseSource from './noise-source';
import BaseNoiseGroup from '../../implementation-common/base-noise-group';

export default class MultipleFeedbackHighPassNoiseGroup extends BaseNoiseGroup {
  r1 = null;
  r2 = null;
  c5 = null;
  c1 = null;
  c2 = null;
  opAmp = null;
  frequencyArray = null;
  @computed('r1', 'r2', 'c1', 'c2', 'c5', 'opAmp', 'filterAmplitude') get noiseReferredToOutputArray() {
    var r1 = this.r1;
    var r2 = this.r2;
    var c1 = this.c1;
    var c2 = this.c2;
    var c5 = this.c5;
    var opAmp = this.opAmp;
    var filterAmplitude = this.filterAmplitude;
    var complexDenominatorArray = filterAmplitude.map((item) => {
      return item.complexDenominator;
    });
    var complexFFDenominatorArray = filterAmplitude.map((item) => {
      return item.complexFFDenominator;
    });
    var sImaginaryArray = filterAmplitude.map((item) => {
      return item.sImaginary;
    });
    var sSquaredArray = filterAmplitude.map((item) => {
      return item.sSquared;
    });
    var iNoise = opAmp.iNoise;
    var vNoise = opAmp.vNoise;
    var rOut = opAmp.rOut;
    var noiseSource = NoiseSource.create({
      r1: r1,
      r2: r2,
      c1: c1,
      c2: c2,
      c5: c5,
      rOut: rOut,
      iNoise: iNoise,
      vNoise: vNoise,
    });
    var result = filterAmplitude.map((item, index) => {
      var complexDenominator = complexDenominatorArray[index];
      var complexFFDenominator = complexFFDenominatorArray[index];
      var sImaginary = sImaginaryArray[index];
      var sSquared = sSquaredArray[index];
      return noiseSource.totalNoise(item, complexDenominator, complexFFDenominator, sImaginary, sSquared);
    });

    return result;
  }

  @computed('noiseReferredToOutputArray', 'magnitude', 'frequencyArray') get noiseReferredToInputArray() {
    var frequencyArray = this.frequencyArray;
    var noiseReferredToOutputArray = this.noiseReferredToOutputArray;
    var magnitude = this.magnitude;
    var result = frequencyArray.map((item, index) => {
      var res = noiseReferredToOutputArray[index] / magnitude[index];
      return res;
    });

    return result;
  }
}
